// extracted by mini-css-extract-plugin
export default {"quotation-form":"QuotationForm_quotation-form__g-v-X"};